import {numberOfCardsPerRow} from "../ConstantsAndHelper";

function Welcome() {
    let dflexStyle = "";

    if (numberOfCardsPerRow() < 3) {
        dflexStyle = " align-items-center flex-column";
    }

    return (
        <div className={"d-flex justify-content-center" + dflexStyle}>

            <div className="card" style={{width: '19rem', margin: '1rem'}}>
                <div className="card-body">
                    <h1 className="card-title">
                        <i className="bi bi-easel"></i>
                    </h1>
                    <h3 className="card-title" style={{marginBottom: '1rem'}}>
                        Lernen
                    </h3>
                    <p className="card-text">
                        Bereiten Sie Ihre Lehrveranstaltungen mit den Materialien und Aufgaben in Quiz and Pass nach.
                    </p>
                </div>
            </div>

            <div className="card" style={{width: '19rem', margin: '1rem'}}>
                <div className="card-body">
                    <h1 className="card-title">
                        <i className="bi bi-laptop"></i>
                    </h1>
                    <h3 className="card-title" style={{marginBottom: '1rem'}}>
                        Üben
                    </h3>
                    <p className="card-text">
                        Führen Sie lehrveranstaltungsbegleitende Übungsaufgaben über Quiz and Pass durch.
                    </p>
                </div>
            </div>

            <div className="card" style={{width: '19rem', margin: '1rem'}}>
                <div className="card-body">
                    <h1 className="card-title">
                        <i className="bi bi-mortarboard"></i>
                    </h1>
                    <h3 className="card-title" style={{marginBottom: '1rem'}}>
                        Bestehen
                    </h3>
                    <p className="card-text">
                        Nutzen Sie Quiz and Pass zur Vorbereitung auf die Prüfung oder Klausur.
                    </p>
                </div>
            </div>

        </div>
    );
}

export default Welcome;